import React, { useState } from "react";
import { FiSave, FiLock } from "react-icons/fi";
import apiService, { API_ENDPOINTS } from "../utils/apiInterceptor";

const Settings = () => {
  const [passwords, setPasswords] = useState({
    oldPassword: "",
    newPassword: "",
  });
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState({ type: "", text: "" });

  const handleInputChange = (field, value) => {
    setPasswords((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMessage({ type: "", text: "" });

    // Validate new password length
    if (passwords.newPassword.length < 6) {
      setMessage({
        type: "error",
        text: "New password must be at least 6 characters long",
      });
      setLoading(false);
      return;
    }

    try {
      await apiService.post(API_ENDPOINTS.AUTH.CHANGE_PASSWORD, passwords);
      setMessage({ type: "success", text: "Password changed successfully!" });
      setPasswords({
        oldPassword: "",
        newPassword: "",
      });
    } catch (error) {
      setMessage({
        type: "error",
        text: error.message || "Failed to change password",
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: "2rem",
        }}
      >
        <h1 style={{ color: "#2c3e50" }}>Settings</h1>
      </div>

      {message.text && (
        <div
          style={{
            background: message.type === "success" ? "#27ae60" : "#e74c3c",
            color: "white",
            padding: "1rem",
            borderRadius: "5px",
            marginBottom: "1.5rem",
            textAlign: "center",
          }}
        >
          {message.text}
        </div>
      )}

      <div className="form-container">
        <h3 style={{ marginBottom: "1.5rem", color: "#2c3e50" }}>
          <FiLock style={{ display: "inline-block", marginRight: "0.5rem" }} />
          Change Password
        </h3>

        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label className="form-label">Old Password</label>
            <input
              type="password"
              className="form-input"
              value={passwords.oldPassword}
              onChange={(e) => handleInputChange("oldPassword", e.target.value)}
              required
            />
          </div>

          <div className="form-group">
            <label className="form-label">New Password</label>
            <input
              type="password"
              className="form-input"
              value={passwords.newPassword}
              onChange={(e) => handleInputChange("newPassword", e.target.value)}
              minLength="6"
              required
            />
            <small style={{ color: "#7f8c8d", fontSize: "0.875rem" }}>
              Must be at least 6 characters long
            </small>
          </div>

          <button
            type="submit"
            className="btn btn-primary"
            disabled={loading}
            style={{ display: "flex", alignItems: "center" }}
          >
            <FiSave style={{ marginRight: "0.5rem" }} />
            {loading ? "Changing..." : "Change Password"}
          </button>
        </form>
      </div>
    </div>
  );
};

export default Settings;
